module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "publish-radio text-center",
    on: {
      "click": _vm.checks
    }
  }, [_c('el-checkbox', {
    ref: "radio",
    staticClass: "radio",
    attrs: {
      "label": _vm.label,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgs"
  }, [_c('img', {
    attrs: {
      "src": _vm.src,
      "width": "60",
      "height": "60"
    }
  })]), _vm._v(" "), (_vm.$slots.default) ? _c('div', {
    staticClass: "name"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-82fcfe88"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/publish_apply/module/checkbox.vue
// module id = 1274
// module chunks = 1